import { render, staticRenderFns } from "./RenewalTable.vue?vue&type=template&id=1ae0d2ff&scoped=true&"
import script from "./RenewalTable.vue?vue&type=script&lang=js&"
export * from "./RenewalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0d2ff",
  null
  
)

export default component.exports